/**
 * Client Spotlight Carousel
 * Cardo 12.04.2025: Per CROWN-1581
 * BEM compliant selectors
 * Pause / Play support added
 * Autoplay starts when carousel enters viewport
 * Progress bar stabilized (RAF-based, pause-safe)
 */

(function (Drupal, $) {
  'use strict';

  Drupal.behaviors.clientSpotlightCarousel = {
    attach: function (context, settings) {

      $('.client-spotlight__field', context)
        .once('clientSpotlight')
        .each(function () {

          var $carousel = $(this);
          var $slider = $carousel.find('.client-spotlight__slider');
          var $pauseButton = $carousel.find('.client-spotlight__pause');
          var $backgrounds = $carousel.find('.client-spotlight__repeating-background');

          // ========================================
          // Background control
          // ========================================
          function updateBackground(index) {
            $backgrounds
              .removeClass('is-active')
              .css('display', 'none');
            $backgrounds
              .filter('[data-bg-index="' + index + '"]')
              .addClass('is-active')
              .css('display', 'block');
          }

          // ========================================
          // Slick Initialization (no autoplay)
          // ========================================

          $slider
            .on('init', function () {
              updateBackground(0);
            })
            .slick({
              infinite: true,
              arrows: false,
              dots: false,
              autoplay: false,
              speed: 500,
              slidesToShow: 1,
              slidesToScroll: 1,
              fade: false,
              cssEase: 'ease-in-out'
            });

          // ========================================
          // Progress Bar Variables
          // ========================================

          var time = 12; // seconds per slide
          var progressBarIndex = 0;
          var isPaused = false;
          var hasStarted = false;

          var startTime = null;
          var elapsedTime = 0;
          var percentTime = 0;
          var rafId = null;

          // ========================================
          // Progress Bar Setup
          // ========================================

          $carousel.find('.client-spotlight__progress-bar').each(function (index) {
            $(this).html(
              '<div class="client-spotlight__progress-fill client-spotlight__progress-fill--' +
              index +
              '"></div>'
            );
          });

          // ========================================
          // Progress Bar Core Logic (RAF-based)
          // ========================================
          function startProgressbar() {
            if (isPaused) return;

            cancelAnimationFrame(rafId);

            startTime = performance.now() - elapsedTime;

            $carousel
              .find('.client-spotlight__progress-item')
              .removeClass('client-spotlight__progress-item--active')
              .eq(progressBarIndex)
              .addClass('client-spotlight__progress-item--active');

            rafId = requestAnimationFrame(updateProgress);
          }

          function updateProgress(timestamp) {
            if (isPaused) return;

            elapsedTime = timestamp - startTime;
            percentTime = elapsedTime / (time * 1000);

            $carousel
              .find('.client-spotlight__progress-fill--' + progressBarIndex)
              .css({ width: Math.min(percentTime * 100, 100) + '%' });

            if (percentTime >= 1) {
              elapsedTime = 0;
              percentTime = 0;

              $slider.slick('slickNext');
              return;
            }

            rafId = requestAnimationFrame(updateProgress);
          }

          function resetProgressbar() {
            cancelAnimationFrame(rafId);
            elapsedTime = 0;
            percentTime = 0;

            $carousel
              .find('.client-spotlight__progress-fill')
              .css({ width: '0%' });
          }

          // ========================================
          // Pause / Play Button
          // ========================================
          $pauseButton.on('click', function () {
            isPaused = !isPaused;
            var $btn = $(this);

            if (isPaused) {
              cancelAnimationFrame(rafId);
              $btn
                .addClass('is-paused')
                .attr('aria-pressed', 'true')
                .attr('aria-label', 'Play slideshow');

            } else {
              $btn
                .removeClass('is-paused')
                .attr('aria-pressed', 'false')
                .attr('aria-label', 'Pause slideshow');
              startProgressbar(); // resumes from elapsedTime
            }
          });

          // ========================================
          // Progress Item Navigation
          // ========================================
          $carousel.find('.client-spotlight__progress-item')
            .on('click keypress', function (e) {
              if (e.type === 'click' || (e.type === 'keypress' && e.which === 13)) {

                cancelAnimationFrame(rafId);

                progressBarIndex = $(this).data('slide-index');
                elapsedTime = 0;
                percentTime = 0;
                $slider.slick('slickGoTo', progressBarIndex, false);

                if (!isPaused && hasStarted) {
                  startProgressbar();
                }
              }
            });

          // ========================================
          // Hover Pause (respects manual pause)
          // ========================================
          $carousel.on('mouseenter', function () {
            cancelAnimationFrame(rafId);
          });

          $carousel.on('mouseleave', function () {
            if (!isPaused && hasStarted) {
              startProgressbar();
            }
          });

          // ========================================
          // Slick Events
          // ========================================
          $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            progressBarIndex = nextSlide;
            updateBackground(nextSlide);
            resetProgressbar();

            if (!isPaused && hasStarted) {
              startProgressbar();
            }
          });

          // ========================================
          // Start autoplay when carousel enters view
          // ========================================
          if ('IntersectionObserver' in window) {
            var observer = new IntersectionObserver(function (entries) {
              entries.forEach(function (entry) {
                if (entry.isIntersecting && !hasStarted) {
                  hasStarted = true;

                  if (!isPaused) {
                    startProgressbar();
                  }

                  observer.unobserve(entry.target);
                }
              });
            }, {
              threshold: 0.5
            });

            observer.observe($carousel[0]);

          } else {
            hasStarted = true;
            if (!isPaused) {
              startProgressbar();
            }
          }
        });
    }
  };
})(Drupal, jQuery);
